import React from 'react';
import Filter from '../../../../components/Filter/Filter/Filter';

const OffersFilter = ({
  className,
  defaultLabel,
  name,
  search,
  onFilterReset,
  items,
  normalizeData,
  onUpdate,
  amount,
}) => {

  const onChange = data => {
    const normalized = normalizeData(data);
    onUpdate({
      [name]: normalized,
    });
  };

  const onReset = () => {
    onFilterReset();
    onUpdate({
      [name]: [],
    });
  };

  return (
    <Filter
      className={className}
      defaultLabel={defaultLabel}
      name={name}
      search={search}
      items={items}
      activeParamsNumber={amount}
      onFilterChange={onChange}
      onFilterReset={onReset}
    />
  );
};

export default OffersFilter;
